// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col, .row {
  height: 100%;
}

checkbox-list {
  flex: 1;
  overflow: hidden;
}

.chart-container {
  height: 100%;
  display: block;
  padding-top: 0px;
  background: white;
}

.sidebar-visible .col-chart {
  right: 280px;
}

.sidebar-float .col-params {
  position: fixed;
  z-index: 1;
}

.col-chart {
  padding-right: 0;
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0px;
  top: 0;
  bottom: 0;
  width: auto;
}

.chart-view-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.view-wrapper {
  overflow: hidden;
  flex-wrap: nowrap;
}

.btnRollUp {
  position: absolute;
  top: 4px;
  left: 10px;
  padding: 0;
  margin: 0;
  height: 30px;
  line-height: 30px;
  color: #0094D1;
}

.btnParams:hover {
  background: #e6e6e6;
}

.btnParams {
  position: absolute;
  top: 4px;
  right: 46px;
  background: transparent;
  border: none;
  width: 26px;
  height: 30px;
  padding-left: 4px;
  display: flex;
  align-items: center;
}

button.btnResetZoom.btn {
  position: absolute;
  top: 4px;
  right: 76px;
  z-index: 1;
  height: 30px;
  font-size: 11px;
  padding: 0px 6px;
  line-height: 30px;
  border-radius: 2px;
}

.btnExport {
  position: absolute;
  top: 4px;
  right: 10px;
  background: transparent;
  border: none;
  width: 26px;
  height: 30px;
  padding-left: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.btnExport:hover {
  background: #e6e6e6;
}

.chart-export-menu {
  position: absolute;
  top: 34px;
  right: 10px;
  background: white;
  border: 1px solid #e6e6e6;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  z-index: 10;
  display: flex;
  flex-direction: column;
}
.chart-export-menu button {
  text-align: left;
  white-space: nowrap;
  padding: 4px 12px;
}
.chart-export-menu button:hover {
  background: #f0f0f0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
